import { initHeroSliders } from '../../../mhg-b2b/src/js/blueprints/heroSlider';
import { initAnimationHouses } from '../../../mhg-global/js/animationHouse';
import { initHistories } from '../../../mhg-global/js/history';
import { initFooterShopNav } from '../../../mhg-global/js/footer';
import { initSearchBar } from '../../../mhg-global/js/searchBar';
import { initItemcardNavigation } from '../../../mhg-global/js/itemcardNavigation';
import { initHeaderTopNavigation } from '../../../mhg-global/js/headerTopNavigation';
import { initItemcardCrosssellerControls } from '../../../mhg-global/js/itemcardCrosssellerControls';
import { fixScrollbars } from '../../../mhg-global/js/scrollbar';
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import {initStickyHeaderHeightVar} from "../../../mhg-global/js/utilities/sticky";
import {initDealerSearch} from "../../../mhg-global/js/dealerSearch";

document.addEventListener('DOMContentLoaded', () => {
    initHeroSliders();
    initAnimationHouses();
    initHistories();
    initFooterShopNav();
    initSearchBar();
    initItemcardNavigation();
    initHeaderTopNavigation();
    initItemcardCrosssellerControls();
    initStickyHeaderHeightVar(document.querySelector('.headerMain'));
    initDealerSearch();
});

window.addEventListener('load', () => requestAnimationFrame(() => fixScrollbars(Swiper, [Autoplay, Navigation])));
